import React from 'react';
import { Link } from "react-router";
import { database, auth } from '../firebase';
import Nav from '../components/Nav';

class KayitOl extends React.Component {
  constructor(props) {
    super(props);
    this.database = database.ref("users");
    this.user = auth.currentUser;
    this.state = {
      user: [],
      id: "",
      errorMessage: "", // state to store error messages
      name: "",
      email: "",
      password: "",
    };
    this.SignUp = this.SignUp.bind(this);
  }

  async SignUp() {
    const { email, password, name } = this.state;

    if (name === "") {
      this.setState({ errorMessage: "Lütfen bir kullanıcı adı girin." });
      return;
    }
    if (email === "") {
      this.setState({ errorMessage: "Lütfen bir E-Posta girin." });
      return;
    }
    if (password === "") {
      this.setState({ errorMessage: "Lütfen bir şifre belirleyin." });
      return;
    }

    document.getElementById("overlay").style.display = "block";
    document.getElementById("overlay-img").style.display = "block";
    
    try {
      await auth.createUserWithEmailAndPassword(email, password);
      auth.onAuthStateChanged((user) => {
        if (user !== null) {
          database.ref('users/' + user.uid).set({
            userName: name,
            email: email,
            // password: password,
            userImage: "",
            uid: user.uid,
            bio: "",
            joined: Date.now(),
          });
          window.location.pathname = "/profil";
        }
      });
    } catch (error) {
      document.getElementById("overlay").style.display = "none";
      document.getElementById("overlay-img").style.display = "none";

      console.log(error.code);
      
      if (error.code === "auth/email-already-in-use") {
        this.setState({ errorMessage: "Bu E-Posta zaten bir kullanıcıya ait." });
      } else if (error.code === "auth/invalid-email") {
        this.setState({ errorMessage: "Lütfen geçerli bir E-Posta adresi girin." });
      } else if (error.code === "auth/weak-password") {
        this.setState({ errorMessage: "Lütfen daha güçlü bir şifre belirleyin." });
      } else {
        this.setState({ errorMessage: "Bir sorun oluştu." });
      }
    }
  }

  render() {
    var load = false;
    auth.onAuthStateChanged(function(user) {
      if (user !== null && load === false) window.location.pathname = "/";
      load = true;
    });

    window.addEventListener("keypress", (e) => {
      if (e.keyCode === 13) document.getElementById("signupbutton").click();
    });

    return (
      <div>
        <Nav />
        <div className="ana">
          <div className="overlay" id="overlay"></div>
          <img src="/loading.svg" className="overlay-img" id="overlay-img" />
          <p style={{ fontWeight: "bold", userSelect: "none" }}>Kaydol</p>
          <div id="errorMessage" className="errorMessage">{this.state.errorMessage}</div>
          <div>
            <input 
              id="name" 
              type="text" 
              placeholder="Kullanıcı Adı" 
              required 
              value={this.state.name}
              onChange={(e) => this.setState({ name: e.target.value })}
              aria-required="true"
            />
          </div>
          <div>
            <input 
              id="email" 
              type="email" 
              placeholder="E-Posta" 
              required 
              value={this.state.email}
              onChange={(e) => this.setState({ email: e.target.value })}
            />
          </div>
          <div style={{ marginTop: 0 }}>
            <input 
              id="pass" 
              type="password" 
              placeholder="Şifre" 
              required 
              value={this.state.password}
              onChange={(e) => this.setState({ password: e.target.value })}
            />
          </div>
          
          <button onClick={this.SignUp} id="signupbutton">Kaydol</button><br /><br />
          <label className="text">Zaten bir hesabın var mı? Seni şuraya alalım: <Link to="/giris-yap">Giriş Yap.</Link></label>

          <style>{`
            .ana {
              position: fixed;
              width: 100%;
              height: 100%;
              padding-top: 200px;
              text-align: center;
              font-size: 30px;
              background: #F57029;
              color: #fff;
            }

            .overlay {
              top: 0;
              left: 0;
              background: #000;
              position: fixed;
              width: 100%;
              height: 100%;
              opacity: 0.7;
              z-index: 888;
              display: none;
            }

            .overlay-img {
              top: 50%;
              left: 50%;
              width: 150px;
              height: 150px;
              position: fixed;
              margin-top: -75px;
              margin-left: -75px;
              z-index: 899;
              display: none;
            }

            .errorMessage {
              color: #000;
              font-size: 16px;
              font-weight: bold;
              margin-top: -30px;
              margin-bottom: 10px;
              padding: 10px 0;
            }

            input {
              padding-left: 15px;
              border: 0;
              border-radius: 20px;
              width: 300px;
              height: 40px;
              outline: none;
              margin-bottom: 10px;
              transition: .2s;
            }

            input:focus {
              background: #ccc;
            }

            button {
              margin-top: 20px;
              width: 100px;
              height: 30px;
              border: 0;
              border-radius: 20px;
              background: #2f2d33;
              color: #fff;
              outline: none;
              transition: .2s;
            }
            
            button:hover {
              background: #5b5b5c;
            }

            .text {
              font-size: 14px;
              display: block;
              margin: auto;
              max-width: 70%;
            }

            .text a {
              color: #000;
            }

            @media (max-width: 623px) {
              html {
                background: #F57029;
              }

              .ana {
                position: fixed;
                padding: 50px 0px;
                margin: 0;
                height: 100%;
              }
            }
          `}</style>
        </div>
      </div>
    );
  }
};

export default KayitOl;